import ConciergeTableContent from '@/components/concierge_table_content/ConciergeTableContent.vue';

export default {
  name: 'ConciergeTable',
  components: { ConciergeTableContent }
};
